<template>
    <div class="newsIndex">
        <div class="content">
            <img src="../../assets/news/bgc.png" alt="">
            <div class="title">关注最新资讯 掌握前沿动态</div>
            <div class="positionContent">
                <div class="positionItem" @click="handelDetail(topingOne)" v-if="JSON.stringify(topingOne) === '{}'">
                    <div class="itemPic"><img :src="topingOne.coverPic" alt=""></div>
                    <div class="positionItemR">
                        <div class="positionItem_title">{{topingOne.title}}<span v-if="topingOne.isOfficialHomeTop" class="topping">置顶</span> </div>
                        <div class="text">{{filterHTMLTag(topingOne.content)}}</div>
                        <div class="time">{{topingOne.publishTime}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="listWrap">
            <div class="positionItem" v-for="item in list" :key="item.articleId" @click="handelDetail(item)">
                <div class="itemPic"><img :src="item.coverPic" alt=""></div>
                <div class="positionItemR">
                    <div class="positionItem_title">{{item.title}}</div>
                    <div class="text">{{filterHTMLTag(topingOne.content)}}</div>
                    <div class="time">{{item.publishTime}}</div>
                </div>
            </div>
        </div>
       <div class="pagination" v-if="list.length > 0">
            <van-pagination v-model="pager.current" :total-items="total" :items-per-page="pager.size"  @change="handleCurrentChange" force-ellipses>
                <template #prev-text>
                    <van-icon name="arrow-left" />
                </template>
                <template #next-text>
                    <van-icon name="arrow" />
                </template>
                <template #page="{ text }">{{ text }}</template>
            </van-pagination>
       </div>
    </div>
</template>

<script>
import { newsList} from '@/api/news'
import to from 'await-to'
export default {
    data() {
        return {
            pager:{
                size:4,
                current:1
            },
            total:0,
            list:[],
            topingOne:'{}',
            newsList:[]
        };
    },
    created() {
        this.newsListData()
    },
    methods: {
        async newsListData(){
            const [res, err] = await to(newsList({ size:this.pager.size,current:this.pager.current}))
            if (err) return this.$toast(err.msg)
            this.list = res.data.list
            // for (let i = 0; i < this.list.length; i++) {
            //     const v = this.list[i];
            //     if(v.isOfficialHomeTop){
            //         this.topingOne = v
            //         this.list.splice(i,1)
            //         return this.topingOne
            //     }else{
            //         this.topingOne = '{}'
            //         return this.topingOne 
            //     }
            // }
            if(this.list.length > 0 ){
                this.list.map((v,i) => {
                    if(v.isOfficialHomeTop){
                        this.topingOne = v
                        this.list.splice(i,1)
                    }else{
                        this.topingOne = '{}'
                    }
                })
            }
            this.total = res.data.total
        },
        handleCurrentChange(e){
            this.pager.current = e
            this.newsListData()
            console.log(this.list);
        },
        handelDetail(item){
            this.$router.push({path:'/news/detail',query:{articleId:item.articleId}})
        },
        filterHTMLTag(content) {
            if(content !== '' && content !== undefined && content !== null ){
                var msg = content.replace(/<\/?[^>]*>/g,"");
                msg = msg.replace(/[|]*\n/,"");//去除行尾空格
                msg=msg.replace(/&npsp;/gi,"");//去掉npsp 
            }else{
                msg = ''
            }
            return msg
        },
    
    }
};
</script>

<style scoped lang="scss">
.newsIndex{
    .content{
        height: 320px;
        position: relative;
        .title{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            font-size: 42px;
            font-weight: 500;
            color: #fff;
            width: 100%;
            text-align: center;
        }
        .positionContent{
            width: 90%;
            position: absolute;
            bottom: -50%;
            left: 50%;
            transform: translate(-50%,-50%); 
        }
    }
    .listWrap{
        width: 90%;
        margin: auto;
        margin-top: 120px;
        .positionItem{
            margin-bottom: 40px;
        }
    }
    .pagination{
        padding:  30px 0;
    }
    .positionItem{
        display: flex;
        align-items: center;
        padding: 20px 15px 30px 15px;
        box-shadow: 0 2px 16px rgba(0,0,0,0.09), 0 0 5px rgba(0,0,0,0.09), 0 0 5px rgba(0,0,0,0.09);  
        background-color: #fff;
        .itemPic{
            width: 160px;
            height: 97px;
        }
        .positionItemR{
            width: calc(100% - 160px);
            margin-left: 20px;
            .positionItem_title{
                font-size: 24px;
                font-weight: 600;
                color: #0e50b2;
                // display: flex;
                // align-items: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                .topping{
                    padding: 2px 5px;
                    color: #fff;
                    background: #004a9f;
                    font-size: 12px;
                    margin-left: 8px;
                }
            }
            .text{
                font-size: 14px;
                color: #555555;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
                overflow:hidden;
            }
            .time{
                color: #7a7979;
                font-size: 14px;
            }
        }
    }
    img{
        width: 100%;
        height: 100%;
    }
}
</style>
